import { UserResourceTypeMappings } from '@aa/nest/auth';
import { createBaseResourceActions } from '../create-base-resource-actions';

// @aa:gen-ignore

const domainSlug = '[USER]';
export const userActions =
  createBaseResourceActions<UserResourceTypeMappings>(domainSlug);
